/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesOfficesResponseSalesOfficeName
 */
export interface SalesOfficesResponseSalesOfficeName {
    /**
     * 営業所ID
     * @type {string}
     * @memberof SalesOfficesResponseSalesOfficeName
     */
    salesOfficeId: string;
    /**
     * 営業所名
     * @type {string}
     * @memberof SalesOfficesResponseSalesOfficeName
     */
    salesOfficeName: string;
}

/**
 * Check if a given object implements the SalesOfficesResponseSalesOfficeName interface.
 */
export function instanceOfSalesOfficesResponseSalesOfficeName(value: object): value is SalesOfficesResponseSalesOfficeName {
    if (!('salesOfficeId' in value) || value['salesOfficeId'] === undefined) return false;
    if (!('salesOfficeName' in value) || value['salesOfficeName'] === undefined) return false;
    return true;
}

export function SalesOfficesResponseSalesOfficeNameFromJSON(json: any): SalesOfficesResponseSalesOfficeName {
    return SalesOfficesResponseSalesOfficeNameFromJSONTyped(json, false);
}

export function SalesOfficesResponseSalesOfficeNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesOfficesResponseSalesOfficeName {
    if (json == null) {
        return json;
    }
    return {
        
        'salesOfficeId': json['sales_office_id'],
        'salesOfficeName': json['sales_office_name'],
    };
}

export function SalesOfficesResponseSalesOfficeNameToJSON(json: any): SalesOfficesResponseSalesOfficeName {
    return SalesOfficesResponseSalesOfficeNameToJSONTyped(json, false);
}

export function SalesOfficesResponseSalesOfficeNameToJSONTyped(value?: SalesOfficesResponseSalesOfficeName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sales_office_id': value['salesOfficeId'],
        'sales_office_name': value['salesOfficeName'],
    };
}

